import React, { useEffect, useRef, useState } from "react";
import { useCookies } from 'react-cookie';
import { Layout } from "antd";
import AppSideBar from "./AppSideBar";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import sensors from 'sa-sdk-javascript';

import VipRechargeModal from "@/componentsNew/VipRechargeModal";
import RetentionRechargeModal from "@/componentsNew/RetentionRechargeModal";
import CouponModal from "./CouponModal";
import AppInstallPrompt from "@/components/AppInstallPrompt";
import { getUserInfo, getWorkUserListNewImgNum, giveCoupon, getWorkInfo, getAiConversionQualification, getRetentionPopup } from "@/api/index";
import { DRAW_SERVICE_ID } from "@/consts";
import ThankModal from "./ThankModal";
import AppSideBarNew from "./AppSideBarNew";
import HeaderBar3 from "./HeaderBar3";
import RechargeGuideModal from "@/components/RechargeGuideModal";
import RechargeRegularPopup from "@/components/RechargeRegularPopup";
import { refreshAiConversionQualification } from '@/utils/checkAiConversionPopup';
import { LOGIN_STATUS } from '@/views/AIEditV3/consts'
import { getIsMobileDevice } from '@/views/AIEditV3/utils/utils'
import { CHANNEL_CODE } from '@/consts/newConsts'
import NewUserModal from './NewUserModal'
import LoginGoodModal from './LoginGoodModal'


import { AI_CHANGE_PIC_GUIDE_SESSION_KEY, AIZhuanhuacelueExposure } from '@/utils/sensorsFunc'
const { Sider } = Layout;

const MainLayout = (props) => {
  const { userInfo, setUserInfo, setLoginStatus, appUserInfo, setAppUserInfo, updateWorkManageUnReadNum, couponModalVisible,
    updateCouponModalVisible, appInstallPromptVisible,
    vipRechargeModalVisible, setVipRechargeModalVisible, setMemberLocation, setLoginStatue, setIsMobileDevice, updateAiSource,
     aiRegularPopupVisible, setAiRegularPopupVisible, aiSource
   } = props;
  const isLykClient = [6, 7, 10, 11, 12, 30].includes(Number(aiSource));
  const [cookies, setCookie] = useCookies(['name']);
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpenCache, setIsOpenCache] = useState(false);
  const [rechargeGuideVisible, setRechargeGuideVisible] = useState(false);
  const [retentionPopupVisible, setRetentionPopupVisible] = useState(false);
  const [retentionPackage, setRetentionPackage] = useState(null);
  const retentionRequestRef = useRef(false);
  const rechargeGuideExposedRef = useRef(false);
  const regularPopupExposedRef = useRef(false);
  const { serverId } = useParams();
  const isLogin = !!userInfo
  const initUserLogin = () => {
    // 开发本地环境
    if(process.env.REACT_APP_ENV === 'dev' && process.env.NODE_ENV === 'development') {
      window.setCookie = setCookie;
    }
    let user_info = userInfo
    getUserInfo({
      invite_code: localStorage.getItem('userInviteCode')
    }).then(res => {
      if (res.status == 403) {
        sessionStorage.removeItem(AI_CHANGE_PIC_GUIDE_SESSION_KEY)
        const cacheUnLoginDrawData = localStorage.getItem('cacheUnLoginDrawData');
        const cacheUnLoginEditData = localStorage.getItem('cacheUnLoginEditData')
        localStorage.clear()
        if(cacheUnLoginDrawData) localStorage.setItem('cacheUnLoginDrawData', cacheUnLoginDrawData);
        if(cacheUnLoginEditData) localStorage.setItem('cacheUnLoginEditData', cacheUnLoginEditData);

        if (serverId === DRAW_SERVICE_ID[process.env.REACT_APP_ENV]) {
          navigate(`/main/AIDraw${location.search || ''}`);
        }else{
          if(location.pathname.indexOf('/main/channel') > -1){
            let urlHost = process.env.REACT_APP_ENV === 'pro' ? 'https://user.3d66.com' : 'https://usertest.3d66.com';
            window.location.href = `${urlHost}/login?login_type=ai_platform&login_url=${encodeURIComponent(window.location.href)}`;
          }
        }

        document.cookie = "login_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"; // 让cookie过期

        setLoginStatue(LOGIN_STATUS.LOGOUT)
      } else if (res.status == 200) {
        // localStorage.setItem("imToken", res.data.token);
        user_info = res.data;
        user_info.accessToken = res.data.token;
        
        sensors.login(res.data.user_id);

        localStorage.setItem("userInfo", JSON.stringify(user_info));
        setLoginStatus(true);
        setLoginStatue(LOGIN_STATUS.LOGIN)

        if (window.location.search.indexOf('ai_source=8') > -1) {
          localStorage.setItem('openByWebApp', '1');
        } else {
          localStorage.removeItem('openByWebApp');
        }

        setUserInfo(user_info);

        reactVipPathSkip();  // 响应主站新vip弹窗跳转

        setLoginStatus(false);
        const { nickname, avatarurl } = user_info;
        const dl = {
          nickname: nickname,
          avatarurl: avatarurl,
          uid: user_info.user_id
        }
        getWorkUserListNewImgNum().then((res) => {
          if(res.status==1){
            updateWorkManageUnReadNum(res.data);
          }
        })

        setAppUserInfo({ ...appUserInfo, [user_info.user_id]: dl });
        // 新版没有新手引导关闭 直接查询是否发放优惠券
        giveCoupon().then(res => {
          updateCouponModalVisible(res.status === 200);
        });

      }
    });
  }
  const [isFromSu, setIsFromSu] = useState(false)
  // 最外围更新ai_source
  useEffect(() => {
    let urlParms = new URLSearchParams(location.search);
    const ai_source = urlParms.get('ai_source');

    // 更新ai_source
    if (ai_source) {
      updateAiSource(ai_source);
    }
    if(localStorage.getItem('openByWebApp')){
      updateAiSource(8);
    }

    // 插件渲染页不显示站点侧边栏；SU 和 Max 共用插件布局。
    setIsFromSu(ai_source === CHANNEL_CODE.SU || ai_source === CHANNEL_CODE.MAX)

  }, [location]);

  const reactVipPathSkip = async () => { //响应主站新vip弹窗跳转
    const params = new URLSearchParams(location.search);
    if (params.get('openVip') === '1') {
      setVipRechargeModalVisible(true)
      setIsOpenCache(true)
      setMemberLocation(35) // 由新版会员弹窗跳转
    }else{
      setVipRechargeModalVisible(false)
      setMemberLocation(0)
    }
  }

  useEffect(() => {
    initUserLogin();
    
    // 是否是移动设备
    setIsMobileDevice(getIsMobileDevice())
  }, []);

  // 登录后查询算力召回弹窗资格。
  useEffect(() => {
    if (!isLogin) return;
    getAiConversionQualification().then((res) => {
      setRechargeGuideVisible(res?.status === 200 && res?.data?.show_recall_popup === true);
    }).catch(() => {
      setRechargeGuideVisible(false);
    });
  }, [isLogin]);

  useEffect(() => {
    if (rechargeGuideVisible && !rechargeGuideExposedRef.current) {
      AIZhuanhuacelueExposure(2);
      rechargeGuideExposedRef.current = true;
    } else if (!rechargeGuideVisible) {
      rechargeGuideExposedRef.current = false;
    }
  }, [rechargeGuideVisible]);

  useEffect(() => {
    if (aiRegularPopupVisible && !regularPopupExposedRef.current) {
      AIZhuanhuacelueExposure(1);
      regularPopupExposedRef.current = true;
    } else if (!aiRegularPopupVisible) {
      regularPopupExposedRef.current = false;
    }
  }, [aiRegularPopupVisible]);

  const handleVipModalAfterClose = async (closedTab) => {
    if (closedTab === 'power' || !isLogin || retentionRequestRef.current) return;

    retentionRequestRef.current = true;
    try {
      const res = await getRetentionPopup();
      const packageInfo = res?.data?.package;
      if (res?.status === 200 && Number(res?.data?.is_need_pop) === 1 && packageInfo?.id) {
        setRechargeGuideVisible(false);
        setAiRegularPopupVisible(false);
        setRetentionPackage(packageInfo);
        setRetentionPopupVisible(true);
      }
    } catch {
      // 资格查询失败不影响会员充值弹窗关闭。
    } finally {
      retentionRequestRef.current = false;
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if(!vipRechargeModalVisible && isOpenCache && params.get('openVip') === '1'){
      window.history.replaceState(null, null, '/#'+location.pathname + location.hash) // 删除参数
    }
  }, [vipRechargeModalVisible]);

  return (
    <Layout style={{ background: "#101112", height: "100vh" }}>
      <>
      {!(isFromSu && location.pathname.includes('AIRender')) && (
          // 加入改图
          !['/pro/Canvas', '/pro/ChangePic'].includes(location.pathname)  &&
             ( location.pathname.indexOf('/pro') > -1 ?
              <Sider style={{  height: "100vh", boxSizing: "border-box", backgroundColor: '#111113' }} width="115" >
                <AppSideBarNew />
              </Sider>
              :
              <Sider style={{  height: "100vh", boxSizing: "border-box", }} width="64" >
                <AppSideBar />
              </Sider>
              )

        )}
        { location.pathname.indexOf('/pro') > -1 && location.pathname.indexOf('/pro/Canvas') < 0  &&
          location.pathname.indexOf('/pro/ChangePic') < 0 &&
          location.pathname.indexOf('/pro/AIEditDetailEnhance')  < 0 &&
          <HeaderBar3 />
        }

        <Outlet />

        <RechargeGuideModal
          compact={isLykClient}
          open={rechargeGuideVisible}
          onClose={() => {
            setRechargeGuideVisible(false);
            void refreshAiConversionQualification();
          }}
          onRecharge={() => {
            setRechargeGuideVisible(false);
            void refreshAiConversionQualification();
            setMemberLocation(35);
            setVipRechargeModalVisible(true);
          }}
        />
        <RechargeRegularPopup
          compact={isLykClient}
          open={aiRegularPopupVisible}
          onClose={() => {
            setAiRegularPopupVisible(false);
            void refreshAiConversionQualification();
          }}
          onRecharge={() => {
            setAiRegularPopupVisible(false);
            void refreshAiConversionQualification();
            setMemberLocation(35);
            setVipRechargeModalVisible(true);
          }}
        />
        <VipRechargeModal onAfterClose={handleVipModalAfterClose} />
        <RetentionRechargeModal
          open={retentionPopupVisible}
          packageInfo={retentionPackage}
          onClose={() => setRetentionPopupVisible(false)}
        />
        { couponModalVisible && <CouponModal /> }
        { appInstallPromptVisible && <AppInstallPrompt /> }

        {/* 新用户赠送30算力 老版 */}
        { userInfo && userInfo?.is_new_user && userInfo?.new_user_ab === 0 && <ThankModal /> }
        {/* 新用户权益弹窗，六次免费和连续七天登录赠送50算力弹窗 */}
        <NewUserModal visible={userInfo &&  userInfo?.is_new_user && userInfo?.new_user_ab === 1} />
        {/* 连续七天登录赠送50算力弹窗 */}
        <LoginGoodModal visible={userInfo && userInfo?.popup_seven_login} />
      </>
    </Layout>
  );
};


const mapStateToProps = ({ app }) => {
  return {
    vipRechargeModalVisible: app.vipRechargeModalVisible,
    aiRegularPopupVisible: app.aiRegularPopupVisible,
    aiSource: app.ai_source,
    userInfo: app.userInfo,
    loginSuccess: app.loginSuccess,
    appUserInfo: app.appUserInfo,
    couponModalVisible: app.couponModalVisible,
    appInstallPromptVisible: app.appInstallPromptVisible,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginStatus: (params) => {
      return dispatch({
        type: "app/setLoginStatus",
        payload: params
      });
    },
    setUserInfo: (params) => {
      return dispatch({
        type: "app/setUserInfo",
        payload: params
      });
    },
    setAppUserInfo: (params) => {
      return dispatch({
        type: "app/setAppUserInfo",
        payload: params
      });
    },
    updateWorkManageUnReadNum: (params) => {
      return dispatch({
        type: "app/updateWorkManageUnReadNum",
        payload: params
      });
    },
    updateCouponModalVisible: (params) => {
      return dispatch({
        type: "app/updateCouponModalVisible",
        payload: params,
      })
    },
    updateDrawInfo: (params) => {
      return dispatch({
        type: "work/updateDrawInfo",
        payload: params,
      })
    },
    updateReDrawInfo: (params) => {
			return dispatch({
				type: "work/updateReDrawInfo",
				payload: params
			});
		},
    setVipRechargeModalVisible: (params) => {
      return dispatch({
          type: "app/setVipRechargeModalVisible",
          payload: params
      });
    },
    setAiRegularPopupVisible: (params) => {
      return dispatch({ type: 'app/setAiRegularPopupVisible', payload: params });
    },
    setMemberLocation:  (params) => {
      return dispatch({
          type: "app/setMemberLocation",
          payload: params
      });
    },
    updateThankModalVisible: (params) => {
      return dispatch({
        type: "app/updateThankModalVisible",
        payload: params,
      })
    },
    updateThankModalVipVisible: (params) => {
      return dispatch({
        type: 'app/updateThankModalVipVisible',
        payload: params,
      })
    },
    setLoginStatue: (params) => {
      return dispatch({
          type: "app/setLoginStatue",
          payload: params
      });
    },
    setIsMobileDevice:(params) => {
      return dispatch({
          type: "app/setIsMobileDevice",
          payload: params
      });
    },
    updateAiSource: (params) => {
      return dispatch({
          type: "app/updateAiSource",
          payload: params
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
